module.exports = __webpack_public_path__ + "static/ReelForWebsite-4febde8e15e5695010f6bd0ae032ef23.mp4";